import xor from 'lodash/xor'

import UserSelector from 'modules/core/components/UserSelector'
import users from 'modules/core/store/collections/users'

import employees from 'modules/employees/store/collections/employees'

interface Props {
  resourceIds: number[]
  setResourceIds: (ids: number[]) => void
}

const ResourceTypes = ({ resourceIds, setResourceIds }: Props) => {
  const onSelect = (accessId: number | null | undefined) => {
    if (!accessId) return setResourceIds([])
    setResourceIds(xor(resourceIds, [accessId]))
  }
  const setAssignees = (ids: number[]) => {
    setResourceIds(ids)
  }
  const invitedEmployees = users.notTerminatedExcludingExternals(employees).filter((user) => user.invited)
  return (
    <UserSelector
      onSelect={onSelect}
      selectedIds={resourceIds}
      onSelectMultiple={setAssignees}
      users={invitedEmployees}
    />
  )
}
export default ResourceTypes
